var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBone = function SvgBone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bone_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bone_svg__a)",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.83 3.83a6.25 6.25 0 0 1 10.665 4.175A6.25 6.25 0 0 1 38.25 20.5c-.568 0-1.12-.12-1.572-.235-.179-.044-.337-.087-.486-.126-.273-.073-.51-.136-.77-.188-.742-.15-1.04-.065-1.288.183l-14 14c-.248.248-.332.546-.183 1.288.052.26.115.497.188.77.04.148.082.307.126.486.114.452.235 1.005.235 1.572a6.25 6.25 0 0 1-12.495.245A6.25 6.25 0 0 1 8.25 26c.567 0 1.12.12 1.572.235.179.044.338.087.486.126.273.073.51.136.77.188.742.15 1.04.065 1.288-.183l14-14c.248-.248.332-.546.183-1.288-.052-.26-.115-.497-.188-.77-.04-.149-.082-.307-.126-.486C26.12 9.37 26 8.817 26 8.25a6.25 6.25 0 0 1 1.83-4.42Zm4.42.67a3.75 3.75 0 0 0-3.75 3.75c0 .243.054.545.16.963.026.106.058.226.092.355.084.316.181.684.249 1.019.2 1.003.285 2.395-.867 3.547l-14 14c-1.152 1.152-2.544 1.068-3.547.867a17.631 17.631 0 0 1-1.019-.249l-.355-.093c-.418-.105-.72-.159-.963-.159a3.75 3.75 0 0 0 0 7.5c1.25 0 2.25 1 2.25 2.25a3.75 3.75 0 1 0 7.5 0c0-.242-.054-.545-.16-.963-.026-.106-.058-.226-.092-.355a17.63 17.63 0 0 1-.249-1.019c-.2-1.003-.285-2.395.867-3.547l14-14c1.152-1.152 2.544-1.068 3.547-.867.335.068.703.165 1.019.249l.355.093c.418.105.72.159.963.159a3.75 3.75 0 1 0 0-7.5A2.25 2.25 0 0 1 36 8.25a3.75 3.75 0 0 0-3.75-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 40c-2 1.2-4.167-.833-5-2l2 5h5l2.5-3-.5-5.5L34.5 19H40l3-2 .5-5-3.5-2c.667.833 1.2 2.6 0 5s-5 1.167-7 0L15.5 33c.667 1.833 1.5 5.8-.5 7Z"
  }))));
};
export default SvgBone;